var debug = {
    log: function() { 
        var args = [].slice.call(arguments);
        var firstarg = args.shift();
        if (typeof firstarg == 'string') args = ['%c' + firstarg, 'color: #080'].concat(args);
        console.log.apply(console, args);
    },
    error: function() { 
        var args = [].slice.call(arguments);
        var firstarg = args.shift();
        if (typeof firstarg == 'string') args = ['%c' + firstarg, 'color: #a58'].concat(args);
        console.error.apply(console, args);
    },
};
